var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-notification',{attrs:{"closable":false,"role":"alert","type":"is-danger is-light"}},[_c('p',[_c('i',{staticClass:"fa fa-exclamation-triangle mr-1"}),_c('b',[_vm._v("Erreur plugin")]),_vm._v(" "),_c('br')]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }